import { RadioGroupTypes, RadioTypes } from '@shared/types';
import { RolePerformerType, RoleType } from '../../lib/api';

export const filterRoleTypes = (performer_type: string) => {
  switch (performer_type) {
    case RolePerformerType.AFM:
      return [
        RoleType.LeaderArrangerComposer,
        RoleType.CopyistSideMusician,
        RoleType.CopyistSideMusician1Double,
        RoleType.CopyistSideMusician2Doubles,
        RoleType.CopyistSideMusician3Doubles,
        RoleType.CopyistSideMusician4Doubles,
      ];

    case RolePerformerType.OnCameraPrincipal:
      return [
        RoleType.Actor,
        RoleType.Singer,
        RoleType.SpecialtyDancer,
        RoleType.SpecialtyAct,
        RoleType.StuntPerformer,
        RoleType.Pilot,
        RoleType.Clown,
      ];

    case RolePerformerType.Extra:
      return [
        RoleType.Actor,
        RoleType.Singer,
        RoleType.SpecialtyDancer,
        RoleType.SpecialtyAct,
        RoleType.StuntPerformer,
        RoleType.Pilot,
        RoleType.Clown,
        RoleType.StandIn,
        RoleType.HandModel,
        RoleType.HandModelDoubleScale,
      ];

    case RolePerformerType.OffCameraPrincipal:
      return [RoleType.Narrator, RoleType.Puppeteer, RoleType.StuntCoordinator];

    // The audio contract's, from the shared lists the wizard uses
    case RolePerformerType.Radio:
      return RadioTypes as RoleType[];

    case RolePerformerType.RadioGroup:
      return RadioGroupTypes as RoleType[];

    default:
      return Object.values(RoleType);
  }
};
